var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'checkbox-container',
    { 'disabled-element': _vm.disabled, 'deactived-element': _vm.deactived } ]},[_c('input',{ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled || _vm.deactived},domProps:{"checked":_vm.checked && !_vm.disabled},on:{"change":_vm.toggle}}),_vm._v(" "),_c('div',{staticClass:"checkbox-restyle"})])}
var staticRenderFns = []

export { render, staticRenderFns }